<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title v-if="mode==='create'">Create Driver Group Data</md-dialog-title>
      <md-dialog-title v-if="mode==='update'">Update Driver Group Data</md-dialog-title>

      <md-dialog-content>
        <form novalidate @submit.prevent="doSave" class="shownoscroll">
          <calling-api type="bar" path="/api/w/stc/updateDriverGroup">
             <md-dialog-actions>
             <md-button class="md-primary" @click="closeDialog();showDialog = false">Close</md-button>
             <md-button type="submit" class="md-primary buttongap">Save</md-button>
             </md-dialog-actions>
          </calling-api>

        <div id="masterData">
          <div class=" md-layout md-gutter md-alignment-center ">
          <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
           <template v-if="create">
            <md-field>
              <label>Driver Group</label>
              <md-input v-model="dataForm.driverGroup"/>
            </md-field>
           </template>
           <template v-else>
            <md-field>
              <label>Driver Group</label>
              <md-input v-model="dataForm.driverGroup" disabled/>
            </md-field>
           </template>
           </div>
           <div style="margin-left:5px;">
            </div>
           <div class="holder md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100">
           <template v-if="create">
            <auto-complete-master-data-select
                                                group="REC_WINDOW"
                                                label="Rev. Windows"
                                                :init-value="dataForm.recWindow"
                                                :on-item-changed="handleWindowsChanged"
                                                >
            </auto-complete-master-data-select>
           </template>
           <template v-else>
            <md-field>
              <label>Receive Window</label>
              <md-input v-model="dataForm.recWindow" disabled/>
            </md-field>
           </template>
           </div>
          </div>
<!----> 
        <hr class="solidLine"/>
        <div class="selectDriverInGpLabel">
           <md-checkbox v-model="selectAllSelDrivers" @change="selectionall('SD')"></md-checkbox>
           <span><label>Selected Driver</label></span>
        </div>
        <div class="selectDriverLabel">
           <md-checkbox v-model="selectAllDrivers" @change="selectionall('D')"></md-checkbox>
           <span><label>Driver</label></span>
        </div>

          <div class="selectedDriverInGroupList">
            <!---
          <pagination-list-only :items="driversinGroup">
        <template slot-scope="{pageItems}">
          <md-card class="data-table-container">
            <div class="outer-container">
             <div class="inner-container">
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.driverId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-checkbox v-model="item.selected">
                        </md-checkbox>
                      </td>
                      
                      <td class="body-cell w5 txtalign">{{item.driverName}}</td>
                      
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </md-card>

        </template>
          </pagination-list-only>
          -->
          <ul>
            <li v-for="item in driversinGroup" v-bind:key="item.driverId">
              <md-checkbox v-model="item.selected"></md-checkbox>
                {{ item.driverName }}
             </li>
            </ul>
          </div>

         
        <div class="selectedDriverList">
          <ul>
            <li v-for="item in driversnotselected" v-bind:key="item.driverId">
              <md-checkbox v-model="item.selected"></md-checkbox>
              {{ item.driverName }}
            </li>
          </ul>

          <!--
          <pagination-list-only :items="driversnotselected">
        <template slot-scope="{pageItems}">
          <md-card class="data-table-container">
            <div class="outer-container">
             <div class="inner-container">
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.driverId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-checkbox v-model="item.selected">
                        </md-checkbox>
                      </td>
                      
                      <td class="body-cell w5 txtalign">{{item.driverName}}</td>
                      
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </md-card>

        </template>
          </pagination-list-only>
          -->
          </div>
          <md-button class="rightToLeft" @click="doSelDriversToDriverGp"><span class="icons-center material-icons"  >arrow_back</span></md-button>
          <md-button class="leftToRight" @click="doSelDriversToSelected"><span class="icons-center material-icons"  >arrow_forward</span></md-button>

          <!--<md-switch v-model="dataForm.active">Active</md-switch>-->
        </div>



        </form>

      </md-dialog-content>
    </md-dialog>
  </div>
</template>
<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
    height: 500px;
  }
  .fixed {
    position: fixed;
  }
  .buttongap {
    margin-left: 10px;
  }
  .shownoscroll {
    overflow: hidden;
  }
  .showscroll {
    overflow: auto;
  }
  .selectedDriverList {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: 250px; 
    height: 290px; 
    margin-left: 380px; 
    margin-top: -290px;
    overflow: auto;
  }
  .selectedDriverInGroupList {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: 250px; 
    height: 290px;
    margin-top: 5px;
    overflow: auto;
  }

  .rightToLeft {
    margin-top: -250px; 
    margin-left: 270px;
  }
  .leftToRight {
    margin-top: -200px; 
    margin-left: -95px;
  }
  .selectDriverInGpLabel {
    margin-top: 17px;
    margin-left: 8px;
  }
  .selectDriverInGpLabel label {
    margin-left: 10px;
    font-size: 18px;
    vertical-align: middle;
  }
  .selectDriverLabel {
    margin-left: 389px; 
    margin-top: -27px;
  }
  .selectDriverLabel label {
    margin-left: 10px;
    font-size: 18px;
    vertical-align: middle;
  }
  .txtalign {
    vertical-align: middle;
  }
  .solidLine {
    border-top: 3px solid #bbb;
  }

  ul {
    list-style-type: none;
    margin-left: 5px;
  }
  
</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { required, } from 'vuelidate/lib/validators';
  import DatePicker from './DatePicker.vue';
  import AutoCompleteStcDriverGroupSelect from '../components/AutoCompleteStcDriverGroupSelect.vue';
  import moment from 'moment';
  import PaginationListOnly from './PaginationListOnly.vue';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialDataForm = () => ({
    driverGroup: null,
    recWindow: null
  });

    const initSearchDriverGroup = () => ({
     seqNo: null,
     driverGroup: null,
     userName: null,
     driverId: null,
     active: true,
     driverName: null,
     recWindow: null
  });

  const getInitDriverSearch = () => ({
     source: null,
     driverOffice: null,
     defaultSalesOffice: null
  });

  const getInitDriverItem = () => ({
     selected: false,
     driverId: null,
     driverName: null
  })

  const initUpdateDriverGroup = () => ({
     driverGroup: null,
     drivers: []
  })

  export default {
  components: { 
     DatePicker,
     AutoCompleteStcDriverGroupSelect, 
     PaginationListOnly
  },
    mixins: [validationMixin,
    PaginationListOnly],
    props: {
      mode: String,
      onUpdate: Function,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialDataForm(),
      searchDriverGroupReq: initSearchDriverGroup(),
      searchDriverSearchReq: getInitDriverSearch(),
      driverItem: getInitDriverItem(),
      updateDriverGroupReq: initUpdateDriverGroup(),
      create: false,
      link: true,
      selectAllDrivers: false,
      selectAllSelDrivers: false,
      stcDriverGroupOption: [],
      drivers: [],
      driverInfo: [],
      //driversFromParams: [],
      driverIds: [],
      driverNames: [],
      driverContent: [],
      driversinGroup: [],
      driversnotselected: []
    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getSaleOfficeMasterData',
        'getPermission',
        'getGSTDriverMaster',
        'getGSTDriverMaster'
      ]),
      // getDispatcherInitValue() {
      //   if (this.mode === 'create') {
      //     return null;
      //   }
      //   return `${this.dataForm.dispatcherName} (${this.dataForm.dispatcherId})`;
      // },
      // getSpecialStatusInitValue() {
      //   if (this.mode === 'create') {
      //     return null;
      //   }
      //   return `${this.dataForm.statusName} (${this.dataForm.statusId})`;
      // },
    },
    watch: {},
    validations: {
      dataForm: {
        driverGroup: {
          required,
        },
        // tagId: {
        //   required,
        // },
        // tagName: {
        //   required,
        // },
      },
    },
    methods: {
      async openDialog(drivergroups, alldrivers, selectedGroup, driversingroup) {
        this.dataForm = getInitialDataForm();
        this.driversinGroup = [];
        this.driversnotselected = [];
        //this.$v.dataForm.$reset();
        console.log('driver groups: ', JSON.stringify(drivergroups));
        console.log('all drivers: ', JSON.stringify(alldrivers));
        console.log('selected group: ', JSON.stringify(selectedGroup));
        console.log('driversingroup: ', JSON.stringify(driversingroup));

        if (this.mode === 'update') {
           console.log("update");
           this.create = false;
        } else {
           console.log("create");
           this.create = true;
        }

        if (selectedGroup && selectedGroup != "") {
           this.dataForm.driverGroup = selectedGroup;
        }
        if (driversingroup && driversingroup.length > 0) {
          this.dataForm.recWindow = driversingroup[0].recWindow;
          driversingroup.forEach((it) => {
            this.driversinGroup.push({ selected: false, driverId: it.driverId, driverName: it.driverName, 
                   userName: it.userName, seqNo: it.seqNo, recWindow: this.dataForm.recWindow, driverGroup: this.dataForm.driverGroup}); 
          });
          this.driversinGroup = this.driversinGroup.sort((a,b) => {if (a.driverName < b.driverName) return -1; if (a.driverName > b.driverName) return 1; return 0;});
          console.log('driver in group: ', this.driversinGroup);
          this.stcDriverGroupOption = drivergroups;
        }
        //this.driversinGroup = driversingroup;
        //this.driversFromParams = alldrivers;
        //this.doDriverSearch();
        this.drivers = alldrivers;
        //this.driversnotselected = [];
        if (this.drivers && this.drivers.length > 0) {
           console.log("all drivers is not empty: " + this.drivers.length);
           if (driversingroup && driversingroup.length > 0) {
             this.drivers.forEach( (it) => {
               console.log("userName: " + it.userName);
               //var obj = driversingroup.filter( (a) => a.driverName == it.shortId);
               var obj = driversingroup.filter( (a) => a.userName == it.userName);
               //console.log("obj len: " + obj.length + ", shortId: " + it.shortId);
               console.log("obj len: " + obj.length + ", userName: " + it.userName);
               if (obj.length <= 0) { 
                  //this.getInitDriverItem();
                  //this.driverItem.selected = false;
                  //this.driverItem.driverId = it.driverId;
                  //this.driverItem.driverName = it.shortId;
                  //this.driversnotselected.push(this.driverItem);
                  console.log("drivers in group in foreach: " + it + ". driverId: " + it.driverId + ", userName: " + it.userName);
                  this.driversnotselected.push({ selected: false, driverId: it.driverId, driverName: it.shortId, userName: it.userName, 
                             seqNo: null, recWindow: this.dataForm.recWindow, driverGroup: this.dataForm.driverGroup}); 
               }
             });
           } else {
             console.log("no selectedgroupdriver");
             this.drivers.forEach ( (it) => {
                 console.log("drivers in foreach: " + it + ". driverId: " + it.driverId + ", shortId: " + it.shortId);
                //this.getInitDriverItem();
                //this.driverItem.selected = false;
                //this.driverItem.driverId = it.driverId;
                //this.driverItem.driverName = it.shortId;
                //console.log("driverItem driverId: " + this.driverItem.driverId + ", shortId: " + this.driverItem.driverName);
                //this.driversnotselected.push(this.driverItem);
                this.driversnotselected.push({ selected: false, driverId: it.driverId, driverName: it.shortId, userName: it.userName, 
                            seqNo: null, recWindow: this.dataForm.recWindow, driverGroup: this.dataForm.driverGroup});
             });
           }
           this.driversnotselected = this.driversnotselected.sort((a,b) => {if (a.driverName < b.driverName) return -1; if (a.driverName > b.driverName) return 1; return 0;});
           //this.driversnotselected = this.drivers;
        }
        console.log("driversnotselected with selected: ", JSON.stringify(this.driversnotselected));
        this.showDialog = true;
      },
      closeDialog(){
        this.isMaster = true,
        this.isCarrier = false,
        this.isLocation = false,
        this.isRoute = false,
        this.isChassis = false,
        this.isCustomer = false,
        this.isTruck = false,
        this.isLeaseChassis = false,
        this.isRateBill = false,
        this.isRateCost = false
        this.isAppMaster = false;
        this.isYGMaster = false;
        this.isScaleMaster = false;
        this.isUpgradeMaster = false;
        this.isWeightControl = false;
      },
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      async doSave() {
        // this.$v.dataForm.$touch();

        // if (this.$v.dataForm.$invalid) {
        //   return;
        // }


        //this.$store
        //  .dispatch(
        //    "updateMasterDataGroup",
        //    this.dataForm.group,
        //  ).then( () => {console.log("save Master Data Group" + this.dataForm.group);});

      
        // this.$store
        //   .dispatch(
        //     "updateMasterData",
        //     this.dataForm,
        //   )
        //   .then(() => {
        //     //console.log("save master data info");
        //     this.showDialog = false;
        //     this.onUpdate();
        //   });
        if ((this.dataForm.driverGroup && this.dataForm.driverGroup != "") &&
            (this.dataForm.recWindow && this.dataForm.recWindow != "")) {
           this.updateDriverGroupReq.driverGroup = this.dataForm.driverGroup;   
           this.updateDriverGroupReq.drivers = this.driversinGroup;
           console.log("updatedrivergroupreq: " + JSON.stringify(this.driversinGroup));
           //this.showDialog = false;
           //await api.post('/api/w/stc/updateDriverGroup',this.updateDriverGroupReq).then(
           await newAPIPost('/api/w/stc/updateDriverGroup',this.updateDriverGroupReq).then(
              this.showDialog = false
           );
        } else {
           alert("Please input driver group and receiving window info before SAVE!"); 
        }
      },
      doSelDriversToDriverGp() {
        var selectedDrivers = this.driversnotselected.filter((it) => it.selected == true);
        console.log("selected driver: " + JSON.stringify(selectedDrivers));
        if (selectedDrivers && selectedDrivers.length > 0) {
           if (selectedDrivers.length == this.driversnotselected.length) {
              this.driversinGroup = this.driversinGroup.concat(selectedDrivers);
              console.log("driversinGroup in doSelDriversToDriverGp: " + JSON.stringify(this.driversinGroup));
              this.driversinGroup.forEach((it) => {
                 it.selected = false;
              });
              this.driversnotselected = [];
           } else {
              console.log("select individual driver");
              selectedDrivers.forEach( (it) => {
                this.driversinGroup.push({selected: false, driverId: it.driverId, driverName: it.driverName, userName: it.userName, 
                             seqNo: it.seqNo, recWindow: this.dataForm.recWindow, driverGroup: this.dataForm.driverGroup});
                this.doRemoveItem(this.driversnotselected,it.userName);
                this.driversnotselected = this.driversnotselected.sort((a,b) => a.driverName > b.driverName);
              });
           }
           this.driversinGroup = this.driversinGroup.sort((a,b) => {if (a.driverName < b.driverName) return -1; if (a.driverName > b.driverName) return 1; return 0;});
           this.selectAllSelDrivers = false;
           this.selectAllDrivers = false;
        }

        // if (selectedDrivers && selectedDrivers.length > 0) {
        //    selectedDrivers.forEach( (it) => {
        //       this.driversinGroup.push({selected: false, driverId: it.driverId, driverName: it.driverName, userName: it.userName, 
        //                    seqNo: it.seqNo, recWindow: this.dataForm.recWindow, driverGroup: this.dataForm.driverGroup});
        //       this.doRemoveItem(this.driversnotselected,it.driverName);
        //    });
        //    this.driversinGroup = this.driversinGroup.sort((a,b) => a.driverName > b.driverName);
        //    this.driversnotselected = this.driversnotselected.sort((a,b) => a.driverName > b.driverName);
        // } 
      },
      doSelDriversToSelected() {
        var selectedDrivers = this.driversinGroup.filter((it) => it.selected == true);
        console.log("selected driver1: " + JSON.stringify(selectedDrivers));
        if (selectedDrivers && selectedDrivers.length > 0) {
           if (selectedDrivers.length == this.driversinGroup.length) {
              this.driversnotselected = this.driversnotselected.concat(selectedDrivers);
              console.log("driversnotselected in doSelDriversToSelected: " + JSON.stringify(this.driversnotselected));
              this.driversnotselected.forEach((it) => {
                   it.selected = false; 
              });
              this.driversinGroup = [];
           } else {
              console.log("select individual driver1");
              selectedDrivers.forEach( (it) => {
                this.driversnotselected.push({selected: false, driverId: it.driverId, driverName: it.driverName, userName: it.userName, 
                             seqNo: it.seqNo, recWindow: this.dataForm.recWindow, driverGroup: this.dataForm.driverGroup});
                this.doRemoveItem(this.driversinGroup,it.userName);
                this.driversinGroup = this.driversinGroup.sort((a,b) => a.driverName > b.driverName);
              });
           }
           this.driversnotselected = this.driversnotselected.sort((a,b) => {if (a.driverName < b.driverName) return -1; if (a.driverName > b.driverName) return 1; return 0;});
           this.selectAllSelDrivers = false;
           this.selectAllDrivers = false;
        }


        // if (selectedDrivers && selectedDrivers.length > 0) {
        //    selectedDrivers.forEach( (it) => {
        //       this.driversnotselected.push({selected: false, driverId: it.driverId, driverName: it.driverName, userName: it.userName, 
        //                    seqNo: it.seqNo, recWindow: this.dataForm.recWindow, driverGroup: this.dataForm.driverGroup});
        //       this.doRemoveItem(this.driversinGroup,it.driverName);
        //    });
        //    this.driversnotselected = this.driversnotselected.sort((a,b) => a.driverName > b.driverName);
        //    this.driversinGroup = this.driversinGroup.sort((a,b) => a.driverName > b.driverName);
        // } 
      },
      doRemoveItem(obj, userName) {
        var index = 0;
        if (obj) {
           obj.forEach((it) => {
              //if (it.driverName == driverName) {
              if (it.userName == userName) { 
                  obj.splice(index, 1);
                  return;
              }
              index += 1;
           });
        } 
      },
      selectionall(type) {
        console.log("selectall: " + type + ", selectAllDrivers: " + this.selectAllDrivers + ", selectAllSelDrivers: " + this.selectAllSelDrivers);
        if (type == "D") {
              this.driversnotselected.forEach( (it) => {
                   if (this.selectAllDrivers == true) {
                      it.selected = true;
                   } else {
                      it.selected = false;
                   }
              });
        } 
        if (type == "SD") {
          this.driversinGroup.forEach( (it) => {
                   if (this.selectAllSelDrivers == true) {
                      it.selected = true;
                   } else {
                      it.selected = false;
                   }
              });

        }
      },
      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },
      handleWindowsChanged(id) {
        this.dataForm.recWindow = id;
      },
      async doDriverGroupSearch(drivergroup) {
        console.log("call doDriverGroupSearch");
        if (drivergroup && drivergroup != "") {
           this.searchDriverGroupReq.driverGroup = drivergroup;
           //return await api.post('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
           return await newAPIPost('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
             if (drivergroup && drivergroup != "") {
                this.driversinGroup = driverGroup;
                console.log('driversingroup: ', this.driversinGroup);
             } else {
                this.stcDriverGroups = driverGroup;
             }   
           })
        }

      },
      async doDriverSearch() {
        this.searchDriverSearchReq.driverOffice = "STC";
        this.searchDriverSearchReq.defaultSalesOffice = "LGB";
        this.$store.dispatch('gstDriverMaster', this.searchDriverSearchReq);
        this.updateDrivers(this.getGSTDriverMaster); 
      },
      async updateDrivers(itemsSource) {
           console.log("update drivers itemsource: " + JSON.stringify(itemsSource));
           console.log("update drivers itemsource with filter: " + JSON.stringify(itemsSource.filter(it => it.driverOffice == "STC")));
           var items = itemsSource.filter( it => it.driverOffice == "STC");
           if (items && items.length > 0) {
              this.drivers = items;
           } else {
              //await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverSearchReq)
              await newAPIPost('/api/w/gstMasterData/driverMasterData', this.searchDriverSearchReq)
                 .then ( (driverinfo) => {
                    if (driverinfo) {
                        this.drivers = driverinfo.filter( (it) => {it.driverOffice == "STC"});
                    }
                 });

           }
           console.log("drivers: [[" + this.drivers + "]]");
      },
      disabledrivergroup() {
         return this.create;
      },
      updatechkbox(item) {
         console.log("update check box");
         item.selected = !item.selected;
      },
    },
  };
</script>
